const getOgImageLink = (pageTitle) =>
  `https://og-image-j5av8lms1-remoteteam.vercel.app/` +
  `${encodeURIComponent(pageTitle)}.png?theme=dark` +
  `&fontSize=110px` +
  `&images=https://res.cloudinary.com/dhikr-zikir-zikirmatik/image/upload/c_scale,q_auto,w_510/v1645530942/website/logo.png`;

module.exports = getOgImageLink;
